import { Box, Theme, Typography, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import clsx from 'clsx';
import { CustomerAccountActivationsState } from './types';

const useStyles = makeStyles()((theme: Theme) => ({
  buttonsWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: '8px',
    flexWrap: 'wrap',
  },
  buttonContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '12px',
    fontWeight: '500',
    fontFamily: 'Inter',
    padding: '7px',
    width: '100%',
    borderRadius: '4px',
  },
  buttonsGroupLabel: {
    color: theme.palette.secondary.main,
    textAlign: 'start',
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: 'normal',
    textTransform: 'capitalize',
    marginBottom: '3px',
  },
  buttonDisabled: {
    color: 'rgba(255, 255, 255, 0.3)',
    background: 'rgba(255, 255, 255, 0.12)',
  },
}));

interface ClientActivationsContainerProps {
  buttonGroupLabel: string;
  accountActivationsState: CustomerAccountActivationsState;
  maxWidth?: string;
}

const ClientActivationsContainer = ({
  buttonGroupLabel,
  accountActivationsState,
  maxWidth,
}: ClientActivationsContainerProps) => {
  const theme = useTheme();
  const styles = useStyles();

  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Typography className={styles.classes.buttonsGroupLabel}>{buttonGroupLabel}</Typography>
      <Box className={styles.classes.buttonsWrapper}>
        {Object.values(accountActivationsState).map((state, idx) => (
          <Box
            maxWidth={maxWidth}
            className={clsx(styles.classes.buttonContainer)}
            key={idx}
            bgcolor={state.isActive ? theme.palette.success.main : theme.palette.error.main}
          >
            {state.label}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ClientActivationsContainer;
